export const ROUTES = {
  LIST: '/',
  CREATE: '/create',
  DETAIL: '/detail/:ticketId',
  EDIT: '/edit/:ticketId',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
